import { ENotificationFrequency } from '../../../repositories/monolithPython/v1/create-subscription';

export type TNotificationFrequencyValue = 1 | 2 | 3;

export function mapNotificationFrequency(value: TNotificationFrequencyValue): ENotificationFrequency {
  const notificationMap: {[key: number]: ENotificationFrequency} = {
    1: ENotificationFrequency.EveryHour,
    2: ENotificationFrequency.EveryDay,
    3: ENotificationFrequency.EveryWeek,
  };

  return notificationMap[value];
}

export const NOTIFICATION_FREQUENCY = [
    { value: 1, label: 'Каждый час' },
    { value: 2, label: 'Каждый день' },
    { value: 3, label: 'Раз в неделю' },
  ];

export function getFormattedLabel(index: number): string {
  const valueObject = NOTIFICATION_FREQUENCY[index - 1];

  if (valueObject) {
    const originLabel = valueObject.label;

    return `Получать ${originLabel.toLowerCase()}`;
  }

  return '';
}
